import { useState, useEffect } from 'react';

/**
 * Tiny store so the navbar knows whether a Gallery section actually exists on
 * the page. The gallery only renders once the owner has published a photo, and
 * a nav link that scrolls to nothing is worse than no link at all.
 */

let present = false;
const listeners = [];

export function setGalleryPresent(value) {
  if (present === value) return;
  present = value;
  listeners.forEach((listener) => listener(value));
}

export function useGalleryPresent() {
  const [value, setValue] = useState(present);

  useEffect(() => {
    listeners.push(setValue);
    // Catches the case where the gallery resolved before this subscriber
    // mounted, which is the normal ordering on a fast connection.
    setValue(present);
    return () => {
      const index = listeners.indexOf(setValue);
      if (index !== -1) listeners.splice(index, 1);
    };
  }, []);

  return value;
}
